import { render, staticRenderFns } from "./PrivacyHeader.vue?vue&type=template&id=107bd7b5&"
import script from "./PrivacyHeader.vue?vue&type=script&lang=js&"
export * from "./PrivacyHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports